import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const City = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
        };
        state = {
            current: 0,
        };
        handleCityMouseOver = index => {
            this.setState({
                current: index,
            });
        };
        render() {
            const { content } = this.props;
            const { current } = this.state;

            const cityList = content.map((item, index) => {
                // var obj = {a:1};
                // obj.a  obj[a] obj.{a}
                console.log('styles:', styles);
                const cityClass = styles[item.class];

                if (index === current) {
                    return (
                        <div
                            className={`${styles.city} ${cityClass} ${styles.current}`}
                            key={index}
                            onMouseOver={() => this.handleCityMouseOver(index)}>
                            <img src={item.src} alt="" />
                        </div>
                    );
                } else {
                    return (
                        <div
                            className={`${styles.city} ${cityClass} `}
                            key={index}
                            onMouseOver={() => this.handleCityMouseOver(index)}>
                            <img src={item.src} alt="" />
                        </div>
                    );
                }
            });

            const list = info => {
                const listtext = info.map((item, index) => {
                    return (
                        <tbody key={index}>
                            <tr>
                                <td className={styles.xj_bg}>{item.school}</td>
                                <td>{item.date}</td>
                                <td>{item.time}</td>
                                <td>{item.addr}</td>
                            </tr>
                        </tbody>
                    );
                });

                return listtext;
            };
            const cityInfoList = content.map((item, index) => {
                const infoList = list(item.infoList);

                if (index === current) {
                    return (
                        <div style={{ display: 'block' }} key={index}>
                            <div className={styles.xj_title}>
                                <span>宣讲 -</span>
                                {item.area}
                            </div>
                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                {infoList}
                            </table>
                        </div>
                    );
                } else {
                    return (
                        <div style={{ display: 'none' }} key={index}>
                            <div className={styles.xj_title}>
                                <span>宣讲 -</span>
                                {item.area}
                            </div>
                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                {infoList}
                            </table>
                        </div>
                    );
                }
            });

            return (
                <div>
                    {cityList}
                    <div className={styles.xj_mid}>{cityInfoList}</div>
                </div>
            );
        }
    },
);

export { City };
export default City;
